'use strict';
angular.module('impactx.moneyInput', [])
    .directive('appInternalMoneyInput', ['$locale', function($locale) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController)
            {
                var mainSymbol = " ";
                var oldViewValue;
                var formats = $locale.NUMBER_FORMATS;

                scope.$watch(function () {
                        return scope.maxPriceDigits;
                    },
                    function (newValue, oldValue)
                    {
                        if(newValue != oldValue)
                        {
                            ngModelController.$setViewValue(scope.getViewValue(ngModelController.$modelValue));
                            ngModelController.$rollbackViewValue();
                        }
                    }
                );
                /* only register a watcher if the attribute is set to true. this won't be set in most of the cases
                 because the scope.zeroAllowed attribute shouldn't change dynamically.
                 */
                if (scope.watchZeroAllowed != undefined)
                {
                    scope.$watch(function () {
                            return scope.zeroAllowed;
                        },
                        function (newValue, oldValue)
                        {
                            if (newValue !== oldValue) {
                                if (scope.zeroAllowed)
                                {
                                    ngModelController.$setValidity('iszero', true);
                                }
                                else
                                {
                                    ngModelController.$setValidity('iszero', ngModelController.$modelValue != undefined
                                        && ngModelController.$modelValue != null && ngModelController.$modelValue != 0 &&
                                        ngModelController.$modelValue != 0 + mainSymbol);
                                }
                            }
                        }
                    );
                }
                /* only register a watcher if the attribute is set to true. this won't be set in most of the cases
                 because the scope.mainSymbol attribute shouldn't change dynamically.
                 */
                if (scope.watchMainSymbol != undefined)
                {
                    scope.$watch(function () {
                            return scope.mainSymbol;
                        },
                        function (newValue, oldValue)
                        {
                            if (newValue !== oldValue) {
                                mainSymbol = " " + scope.mainSymbol;
                                if (ngModelController.$viewValue)
                                {
                                    var newViewValue = ngModelController.$viewValue.replace(" " + oldValue, "");
                                    newViewValue = newViewValue.replace(" " + newValue, "");
                                    if (newValue != undefined)
                                    {
                                        newViewValue = newViewValue + " " + newValue;
                                    }
                                    ngModelController.$setViewValue(newViewValue);
                                    ngModelController.$rollbackViewValue();
                                }
                            }
                        }
                    );
                }
                if (scope.watchNegativeAllowed != undefined)
                {
                    scope.$watch(function () {
                            return scope.allowNegative;
                        },
                        function (newValue, oldValue)
                        {
                            if (newValue !== oldValue) {
                                if (scope.allowNegative)
                                {
                                    ngModelController.$setValidity('isnegative', true);
                                }
                                else
                                {
                                    ngModelController.$setValidity('isnegative', ngModelController.$modelValue >= 0);
                                }
                            }
                        }
                    );
                }
                scope.onFocus = function()
                {
                    if (ngModelController.$viewValue)
                    {
                        ngModelController.$setViewValue(ngModelController.$viewValue.replace(mainSymbol, ""));
                        mainSymbol = "";
                        ngModelController.$rollbackViewValue();
                    }
                    element[0].select();
                };
                scope.onBlur = function()
                {
                    if (ngModelController.$modelValue) {
                        var modelValue = Number(ngModelController.$modelValue);
                        if (!isNaN(modelValue)) {
                            ngModelController.$setViewValue(scope.getViewValue(modelValue));
                            ngModelController.$rollbackViewValue();
                        }
                    }
                };
                var regExp = scope.allowNegative ? /[^-?0-9.,]+/ : /[^0-9.,]+/;
                var regExpForNumber = /[^0-9]/g;
                var regExpGroup = new RegExp("[" + formats.GROUP_SEP + "]+", 'g');
                var regExpDecimal = new RegExp("[" + formats.DECIMAL_SEP + "]+", 'g');
                ngModelController.$parsers.push(function (data)
                {
                    if(scope.priceFactor || scope.priceOffset)
                    {
                        //changing the model doesn't make sense with off sets.
                        return ngModelController.$modelValue;
                    }
                    var dataString = data.toString();
                    /* check the maxlength */
                    var splitNumber = dataString.split(formats.DECIMAL_SEP);
                    splitNumber[0] = splitNumber[0].replace(regExpForNumber, "");
                    var decimalSpaces = 0;
                    if (splitNumber[1])
                    {
                        var decimalNumber = splitNumber[1].replace(regExpForNumber, "");
                        decimalSpaces = decimalNumber.length;
                    }
                    if ((splitNumber[0].length + decimalSpaces > 10 || splitNumber[0].length > 8 || decimalSpaces > 9 ||
                        (scope.maxDecimalDigits && decimalSpaces > scope.maxDecimalDigits)) && oldViewValue != undefined)
                    {
                        ngModelController.$setViewValue(oldViewValue);
                        ngModelController.$rollbackViewValue();
                        return ngModelController.$modelValue;
                    }
                    /* more than 1 decimal separator */
                    if (dataString.split(formats.DECIMAL_SEP).length - 1 > 1)
                    {
                        ngModelController.$setViewValue(oldViewValue);
                        ngModelController.$rollbackViewValue();
                        return ngModelController.$modelValue;
                    }
                    /* more than one '-' */
                    if (dataString.split("-").length - 1 > 1)
                    {
                        ngModelController.$setViewValue(oldViewValue);
                        ngModelController.$rollbackViewValue();
                        return ngModelController.$modelValue;
                    }
                    /* '-' somewhere in the middle */
                    if (dataString.indexOf('-') > 0)
                    {
                        ngModelController.$setViewValue(oldViewValue);
                        ngModelController.$rollbackViewValue();
                        return ngModelController.$modelValue;
                    }
                    /* declare here because mainSymbol could change from outside and is changed inside.
                     * onFocus clears the mainSymbol and onBlur initializes it from the scope.mainSymbol,
                     * so we can decide if we allow the 'input' of the currency.*/
                    var regExpWithSymbol = scope.allowNegative ? new RegExp("[^\\-0-9.," + mainSymbol + "]+") : new RegExp("[^0-9.," + mainSymbol + "]+");
                    /* check the allowed symbols */
                    var validInput = dataString.replace(regExpWithSymbol, "");
                    if (data != validInput)
                    {
                        ngModelController.$setViewValue(validInput);
                        ngModelController.$rollbackViewValue();
                        return ngModelController.$modelValue;
                    }
                    var correctedValue = data.replace(mainSymbol, "");
                    correctedValue = correctedValue.replace(regExpGroup, "");
                    correctedValue = correctedValue.replace(regExp, "");
                    correctedValue = correctedValue.replace(regExpDecimal, ".");
                    /* check the validity if the field is zero and zero is not allowed */
                    if (scope.zeroAllowed)
                    {
                        ngModelController.$setValidity('iszero', true);
                    }
                    else
                    {
                        ngModelController.$setValidity('iszero', correctedValue != 0 && correctedValue != 0 + mainSymbol);
                    }
                    if (scope.allowNegative)
                    {
                        ngModelController.$setValidity('isnegative', true);
                    }
                    else
                    {
                        ngModelController.$setValidity('isnegative', correctedValue >= 0);
                    }
                    /* needed for the possibility to reject the input of the user by setting it to the old value. */
                    oldViewValue = ngModelController.$viewValue;

                    if (scope.maintainEmptyInput && dataString.length === 0) {
                        return null;
                    }
                    if(correctedValue === "" && scope.noInputAllowed){
                        return null;
                    }
                    correctedValue = correctedValue * Math.pow(10, 2);
                    return correctedValue;
                });

                scope.getViewValue = function(data)
                {
                    if (scope.mainSymbol)
                    {
                        mainSymbol = " " + scope.mainSymbol;
                    }
                    if (scope.zeroAllowed)
                    {
                        ngModelController.$setValidity('iszero', true);
                    }
                    else
                    {
                        ngModelController.$setValidity('iszero', data !== undefined && data != 0);
                    }
                    if (data)
                    {
                        var negative = false;
                        if (data.toString()[0] === "-")
                        {
                            data = -1 * data;
                            negative = true;
                        }
                        /* maxFrac is depending on the number. The number can have 12 digits. Because there are always
                           two decimal digits we only 'allow' 10 pre decimal digits. So we calculate the max decimal
                           digits by 12(total max) - 1(at least one pre decimal digit - Math.floor(Math.log(data) / Math.log(10))
                           (log10(data) this is the number of pre decimal digits) + 2 (because the number is given with a
                           factor 10)
                         */
                        var maxFrac;
                        if (scope.maxPriceDigits)
                        {
                            maxFrac = scope.maxPriceDigits;
                        }
                        else
                        {
                            maxFrac = 11 - Math.floor(Math.log(data) / Math.log(10));
                        }
                        var pattern =
                            {
                                "gSize": 3,
                                "lgSize": 3,
                                "maxFrac": maxFrac,
                                "minFrac": 2,
                                "negPre": "-",
                                "negSuf": "",
                                "posPre": "",
                                "posSuf": mainSymbol
                            };
                        /* formats the number with the given parameters. It will be formatted with at least 2 decimal places
                         * and the currency (1,00 EUR for example)*/
                        if (scope.priceFactor !== undefined && scope.priceFactor !== null)
                        {
                            data = data * scope.priceFactor;
                        }
                        if (scope.priceOffset !== undefined && scope.priceOffset !== null)
                        {
                            data = data + (!negative ? scope.priceOffset : -scope.priceOffset);
                            if (data < 0)
                            {
                                negative = false;
                                data = -1 * data;
                            }
                        }
                        var formattedNumber = formatNumber(Math.round(data * Math.pow(10, maxFrac + 2)) / Math.pow(10, maxFrac + 4),
                            pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, undefined);
                        return negative ? "-" + formattedNumber : formattedNumber;
                    }
                    else
                    {
                        if (scope.maintainEmptyInput) {
                            if (data === 0) {
                                return "0" + formats.DECIMAL_SEP + "00" + mainSymbol;
                            }
                            else {
                                return null;
                            }
                        }
                        if (scope.noInputAllowed != undefined)
                        {
                            return null;
                        }
                        else
                        {
                            return "0" + formats.DECIMAL_SEP + "00" + mainSymbol;
                        }
                    }
                };
                ngModelController.$formatters.push(scope.getViewValue);
            }
        }
    }])
    .directive('appMoneyInput', ['TranslationService', function(TranslationService) {
        return {
            scope: {
                price : '=',
                mainSymbol : '=',
                zeroAllowed: '=',
                watchZeroAllowed: "@",
                labelRequired: "@",
                dialogData: "=",
                watchMainSymbol : "@",
                watchNegativeAllowed : "@",
                labelNegative : "@",
                name: "@",
                label: "@",
                allowNegative: "=",
                noAsterisk: "=",
                ixDisabled: "=",
                required: "=",
                noInputAllowed: "@",
                priceFactor: "=",
                priceOffset: "=",
                maxPriceDigits: "=",
                onChange: "&",
                maxDecimalDigits: "=",
                maintainEmptyInput: "=",
                displayLabel: "@",
                readOnly: "=",
                useDebounce: "="
            },
            restrict:'E',
            templateUrl: 'shared/input/moneyInputTemplate.html',
            transclude: true,
            link: function (scope)
            {
                scope.zeroNotAllowedLabel = TranslationService.get("zeroNotAllowed");
            }
    }}]);
